import React from 'react'
import LogoImage from '../static/logo.svg'
import * as media from '../media'
import styled from 'styled-components'

const Caption = styled.div`
  font-weight: 600;
  color: #5C707B;
  ${media.smallerThan(960)` display: none;`}
`;

const R = styled.div `
  position: absolute; 
  right: 80px;
  top: 3px;
  color: rgb(23, 61, 176);
  font-weight: 800;
  ${media.smallerThan(960)` right: -13px`}
`

const logo = ({style}) => {
  return (
    <div style={{position: 'relative'}}>
      <img className="logo" src={LogoImage} style={style}/>
      <Caption>auto parts & consumables</Caption>
      <R>®</R>
    </div>
  )
}

export default logo



// WEBPACK FOOTER //
// ./src/finwhale/logo.js